import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema';
import { dropEndpointIds } from 'root/src/shared/drops/drops.constants';
export const uncompletedDropDaresReminderEndpoint = {
    [dropEndpointIds.UNCOMPLETED_DROP_DARES_REMINDER]: {
        payloadSchema: cronJobPayloadSchema,
        isCron: true,
    },
};
